console.log("VPX MEAL GENERATOR FILE LOADED");

(function () {

    if (!window.VORYNEX) {
        console.error("VORYNEX namespace not found. Meal Generator aborted.");
        return;
    }

    if (!window.VORYNEX.foods) {
        console.error("vpx-foods.js must load before vpx-meal-generator.js. Meal Generator aborted.");
        return;
    }

    const FOODS = window.VORYNEX.foods;

    /*
    ==========================================
    Meal Slots & Recipes
    ------------------------------------------
    Each slot (breakfast, lunch, etc.) offers
    MULTIPLE recipe styles the user can switch
    between (e.g. Oatmeal Bowl vs Protein
    Pancakes vs Veggie Omelette for breakfast).
    Whichever recipe is active gets scaled by a
    single per-meal factor so the meal's total
    calories match its share of the daily target
    — this preserves the recipe's inherent macro
    ratio (same proportional-scaling approach as
    before, just applied per chosen recipe).
    ==========================================
    */

    const MEAL_SLOTS = [
        {
            id: "breakfast",
            nameKey: "meal_breakfast",
            icon: "🥣",
            imageFile: "food-breakfast.jpg",
            recipes: [
                {
                    id: "breakfast_oatmeal",
                    nameKey: "recipe_breakfast_oatmeal",
                    items: [
                        { foodId: "oats", grams: 60 },
                        { foodId: "whey_protein", grams: 30 },
                        { foodId: "berries", grams: 80 }
                    ]
                },
                {
                    id: "breakfast_pancakes",
                    nameKey: "recipe_breakfast_pancakes",
                    items: [
                        { foodId: "eggs", grams: 100 },
                        { foodId: "oats", grams: 40 },
                        { foodId: "whey_protein", grams: 20 },
                        { foodId: "banana", grams: 60 }
                    ]
                },
                {
                    id: "breakfast_omelette",
                    nameKey: "recipe_breakfast_omelette",
                    items: [
                        { foodId: "eggs", grams: 150 },
                        { foodId: "whole_wheat_bread", grams: 60 },
                        { foodId: "avocado", grams: 50 }
                    ]
                }
            ]
        },
        {
            id: "lunch",
            nameKey: "meal_lunch",
            icon: "🍗",
            imageFile: "food-lunch.jpg",
            recipes: [
                {
                    id: "lunch_classic",
                    nameKey: "recipe_lunch_classic",
                    items: [
                        { foodId: "chicken_breast", grams: 150 },
                        { foodId: "brown_rice", grams: 150 },
                        { foodId: "broccoli", grams: 150 },
                        { foodId: "olive_oil", grams: 5 }
                    ]
                },
                {
                    id: "lunch_beef_sweet_potato",
                    nameKey: "recipe_lunch_beef_sweet_potato",
                    items: [
                        { foodId: "lean_beef", grams: 130 },
                        { foodId: "sweet_potato", grams: 200 },
                        { foodId: "green_beans", grams: 100 },
                        { foodId: "olive_oil", grams: 5 }
                    ]
                }
            ]
        },
        {
            id: "preWorkout",
            nameKey: "meal_preWorkout",
            icon: "🍌",
            imageFile: "food-preworkout.jpg",
            recipes: [
                {
                    id: "preworkout_banana_ricecakes",
                    nameKey: "recipe_preworkout_banana_ricecakes",
                    items: [
                        { foodId: "banana", grams: 120 },
                        { foodId: "rice_cakes", grams: 30 },
                        { foodId: "honey", grams: 15 }
                    ]
                },
                {
                    id: "preworkout_toast_honey",
                    nameKey: "recipe_preworkout_toast_honey",
                    items: [
                        { foodId: "whole_wheat_bread", grams: 50 },
                        { foodId: "honey", grams: 20 },
                        { foodId: "banana", grams: 80 }
                    ]
                }
            ]
        },
        {
            id: "postWorkout",
            nameKey: "meal_postWorkout",
            icon: "🥤",
            imageFile: "food-postworkout.jpg",
            recipes: [
                {
                    id: "postworkout_shake",
                    nameKey: "recipe_postworkout_shake",
                    items: [
                        { foodId: "whey_protein", grams: 35 },
                        { foodId: "banana", grams: 100 }
                    ]
                },
                {
                    id: "postworkout_shake_plus",
                    nameKey: "recipe_postworkout_shake_plus",
                    items: [
                        { foodId: "whey_protein", grams: 30 },
                        { foodId: "banana", grams: 80 },
                        { foodId: "honey", grams: 10 }
                    ]
                }
            ]
        },
        {
            id: "dinner",
            nameKey: "meal_dinner",
            icon: "🐟",
            imageFile: "food-dinner.jpg",
            recipes: [
                {
                    id: "dinner_salmon",
                    nameKey: "recipe_dinner_salmon",
                    items: [
                        { foodId: "salmon", grams: 150 },
                        { foodId: "quinoa", grams: 120 },
                        { foodId: "spinach", grams: 100 },
                        { foodId: "olive_oil", grams: 5 }
                    ]
                },
                {
                    id: "dinner_turkey_stirfry",
                    nameKey: "recipe_dinner_turkey_stirfry",
                    items: [
                        { foodId: "turkey_breast", grams: 150 },
                        { foodId: "brown_rice", grams: 120 },
                        { foodId: "bell_pepper", grams: 100 },
                        { foodId: "zucchini", grams: 100 },
                        { foodId: "olive_oil", grams: 5 }
                    ]
                }
            ]
        }
    ];

    const REST_DAY_SLOT_IDS = ["breakfast", "lunch", "dinner"];

    /*
    ==========================================
    Optional Condiments (Lunch & Dinner only)
    ------------------------------------------
    Purely informational add-ons — NEVER part of
    the base items array or the optimizer's
    macro-scaling math. Each option shows exactly
    how many extra calories a fixed serving adds,
    so choosing one is fully transparent and never
    silently distorts the calculated meal.
    ==========================================
    */

    const CONDIMENT_SERVINGS = {
        mayo_light: 15,
        ketchup: 20,
        bbq_sauce: 20,
        mustard: 10
    };

    const CONDIMENT_IDS = ["mayo_light", "ketchup", "bbq_sauce", "mustard"];
    const CONDIMENT_SLOT_IDS = ["lunch", "dinner"];

    function buildCondimentOptions() {
        return CONDIMENT_IDS.map(function (id) {
            const food = FOODS[id];
            const grams = CONDIMENT_SERVINGS[id];
            const macros = macrosForGrams(id, grams);
            return {
                id: id,
                nameKey: food.nameKey,
                icon: food.icon,
                grams: grams,
                kcal: Math.round(macros.kcal),
                protein: Math.round(macros.protein * 10) / 10,
                carbs: Math.round(macros.carbs * 10) / 10,
                fat: Math.round(macros.fat * 10) / 10
            };
        });
    }

    /*
    ==========================================
    Macro Math Helpers
    ==========================================
    */

    function macrosForGrams(foodId, grams) {
        const food = FOODS[foodId];
        if (!food) return { kcal: 0, protein: 0, carbs: 0, fat: 0 };
        const factor = grams / 100;
        return {
            kcal: food.kcal100g * factor,
            protein: food.protein100g * factor,
            carbs: food.carbs100g * factor,
            fat: food.fat100g * factor
        };
    }

    function recipeBaselineKcal(recipe) {
        return recipe.items.reduce(function (sum, item) {
            return sum + macrosForGrams(item.foodId, item.grams).kcal;
        }, 0);
    }

    function getSlotRecipe(slot, recipeSelections) {
        const selectedId = recipeSelections && recipeSelections[slot.id];
        if (selectedId) {
            const found = slot.recipes.filter(function (r) { return r.id === selectedId; })[0];
            if (found) return found;
        }
        return slot.recipes[0];
    }

    /*
    ==========================================
    Public API
    ==========================================
    */

    const MealGenerator = {};

    MealGenerator.generate = function (targetCalories, isRestDay, recipeSelections) {

        const activeSlots = isRestDay
            ? MEAL_SLOTS.filter(function (s) { return REST_DAY_SLOT_IDS.indexOf(s.id) !== -1; })
            : MEAL_SLOTS;

        const chosen = activeSlots.map(function (slot) {
            return { slot: slot, recipe: getSlotRecipe(slot, recipeSelections) };
        });

        const baselineTotal = chosen.reduce(function (sum, c) {
            return sum + recipeBaselineKcal(c.recipe);
        }, 0);

        return chosen.map(function (c) {

            const slot = c.slot;
            const recipe = c.recipe;

            const baselineKcal = recipeBaselineKcal(recipe);
            const slotShare = baselineTotal > 0 ? baselineKcal / baselineTotal : (1 / chosen.length);
            const slotTargetKcal = targetCalories * slotShare;
            const scaleFactor = baselineKcal > 0 ? slotTargetKcal / baselineKcal : 1;

            let slotKcal = 0, slotProtein = 0, slotCarbs = 0, slotFat = 0;

            const items = recipe.items.map(function (item) {

                const scaledGrams = Math.max(1, Math.round(item.grams * scaleFactor));
                const macros = macrosForGrams(item.foodId, scaledGrams);

                slotKcal += macros.kcal;
                slotProtein += macros.protein;
                slotCarbs += macros.carbs;
                slotFat += macros.fat;

                const food = FOODS[item.foodId];

                return {
                    foodId: item.foodId,
                    nameKey: food.nameKey,
                    icon: food.icon,
                    grams: scaledGrams,
                    kcal: Math.round(macros.kcal),
                    protein: Math.round(macros.protein * 10) / 10,
                    carbs: Math.round(macros.carbs * 10) / 10,
                    fat: Math.round(macros.fat * 10) / 10,
                    category: food.category,
                    alternatives: food.alternatives || []
                };
            });

            return {
                slotId: slot.id,
                icon: slot.icon,
                nameKey: slot.nameKey,
                imageFile: slot.imageFile,
                recipeId: recipe.id,
                recipeNameKey: recipe.nameKey,
                availableRecipes: slot.recipes.map(function (r) {
                    return { id: r.id, nameKey: r.nameKey };
                }),
                items: items,
                kcal: Math.round(slotKcal),
                protein: Math.round(slotProtein),
                carbs: Math.round(slotCarbs),
                fat: Math.round(slotFat),
                availableCondiments: CONDIMENT_SLOT_IDS.indexOf(slot.id) !== -1 ? buildCondimentOptions() : [],
                selectedCondiments: []
            };
        });
    };

    /*
    ==========================================
    Export
    ==========================================
    */

    window.VORYNEX.mealGenerator = MealGenerator;
    console.log("Meal Generator exported.");

})();